import { Size } from "@/api/AppApi/common-interfaces/api-enums";
import NextImage from "@/app/components/lib/NextImage";
import { getProductBoxDefaultImageDim } from "../../../common/functions";
import { ITheme } from "@/api/AppApi/services/company/interfaces/ICompany";
import ProductBadge from "./ProductBadge";
import {
  DiscountTypes,
  IProduct,
} from "@/api/AppApi/services/home/interfaces/IProduct";

interface Props {
  imgWidth?: number;
  imgHeight?: number;
  className: string;
  src: string;
  is_new: boolean;
  size: Size;
  discount_amount: number;
  discount_type?: DiscountTypes;
  has_discount: boolean;
  priority: boolean;
  discount?: number;
  theme: ITheme | undefined;
  images?: IProduct["images"];
  outOfStock?: boolean;
}

const ProductImg: React.FC<Props> = ({
  className,
  src,
  size,
  is_new,
  has_discount,
  discount_type,
  discount_amount,
  imgWidth,
  imgHeight,
  discount,
  theme,
  images,
  outOfStock,
}) => {
  const { show_discount_badge, show_new_badge, sale_badge_style } =
    theme?.components?.product ?? {};
  const showDiscountBadge = show_discount_badge && has_discount;
  const showNewBadge = show_new_badge && is_new;
  const isSaleLabel = sale_badge_style === "label" && showDiscountBadge;
  const hoverImages =
    images && images.filter((image) => image.thumbnail_url !== src);
  const hoverImage =
    hoverImages && hoverImages.length > 0 ? hoverImages[0].thumbnail_url : "";

  return (
    <div className={className} style={{ position: "relative" }} dir="ltr">
      <NextImage
        height={imgHeight}
        width={imgWidth}
        src={src}
        alt="product"
        objectFit={
          theme?.components?.product.product_image_object_fit
            ? theme?.components?.product.product_image_object_fit
            : "cover"
        }
        sizes={
          [Size.large, Size.vertical_large].includes(size) ? "268px" : "148px"
        }
        containerStyle={{
          paddingTop: imgHeight
            ? 0
            : `max(${getProductBoxDefaultImageDim(size).height}px,100%)`,
        }}
      />
      {hoverImage && (
        <div className="hover-img">
          <NextImage
            height={imgHeight}
            width={imgWidth}
            src={hoverImage}
            alt="product"
            objectFit={
              theme?.components?.product.product_image_object_fit
                ? theme?.components?.product.product_image_object_fit
                : "cover"
            }
            sizes={
              [Size.large, Size.vertical_large].includes(size)
                ? "268px"
                : "148px"
            }
            containerStyle={{
              paddingTop: imgHeight
                ? 0
                : `max(${getProductBoxDefaultImageDim(size).height}px,100%)`,
            }}
          />
        </div>
      )}

      {(showNewBadge || showDiscountBadge || outOfStock) && (
        <ProductBadge
          discount={discount}
          discount_amount={discount_amount}
          size={size}
          discount_type={discount_type}
          showDiscountBadge={showDiscountBadge!}
          showNewBadge={showNewBadge!}
          isSaleLabel={isSaleLabel!}
          outOfStock={outOfStock}
        />
      )}
    </div>
  );
};

export default ProductImg;
